import { Component, EventEmitter, Input, Output } from "@angular/core";


@Component({
    selector: 'app-models-list',
    templateUrl: './models-list.html',
    styleUrls: ['./models-list.css'],
    standalone: false
})
export class ModelsListComponent {
    @Input() list:{_key:string, colour:string, name:string}[]
    
    @Output() modelSelected = new EventEmitter<string>();

    constructor() {}

    selectModel(key:string) {
        this.modelSelected.emit(key)
    }
}